import React from "react";
import { Stack } from "@mui/material";
import { CrmPersonCustomFieldsBox } from "./boxes/CrmPersonCustomFieldsBox.js";
import { CardContainer } from "@msys/ui";
import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import { useCrmPersonEditForm_CrmPersonQuery } from "./CrmPersonEditForm.generated.js";
import {
  CrmPersonAvatarAndTitleData,
  CrmPersonAvatarAndTitleForm,
} from "./CrmPersonAvatarAndTitleForm.js";
import { CrmPersonInformationForm } from "./CrmPersonInformationForm.js";
import { namedOperations } from "../../../clients/graphqlTypes.js";
import { RestrictedByOrganisationPermissionWithDebug } from "../../auth/RestrictedByOrganisationPermission.js";
import { CrmPersonInformationData } from "./CrmPersonInformationData.js";

interface Props {
  crmPersonId: string;
}

export const CrmPersonEditForm = ({ crmPersonId }: Props) => {
  const client = useApolloClient();
  const query = useCrmPersonEditForm_CrmPersonQuery({
    client,
    variables: { crmPersonId },
  });
  const crmPerson = getDataOrNull(query.data?.crmPerson)?.crmPerson;
  return crmPerson ? (
    <Stack spacing={1}>
      <CardContainer>
        <RestrictedByOrganisationPermissionWithDebug
          permission="crm_record_update"
          otherwise={
            <Stack
              direction="column"
              spacing={1}
              sx={{
                p: 1,
              }}
            >
              <CrmPersonAvatarAndTitleData crmPerson={crmPerson} />
              <CrmPersonInformationData crmPerson={crmPerson} />
            </Stack>
          }
        >
          <Stack
            direction="column"
            spacing={1}
            sx={{
              p: 1,
            }}
          >
            <CrmPersonAvatarAndTitleForm crmPerson={crmPerson} />
            <CrmPersonInformationForm crmPerson={crmPerson} />
          </Stack>
        </RestrictedByOrganisationPermissionWithDebug>
      </CardContainer>
      <CrmPersonCustomFieldsBox
        crmPerson={crmPerson}
        onChangeCustomFieldsRefetchQueries={[
          namedOperations.Query.CrmPersonEditForm_CrmPerson,
        ]}
      />
    </Stack>
  ) : null;
};
